<template>
  <div class="form-single-fragment" style="position: relative;">
    <el-form ref="EditPaNotify" :model="formData" class="full-width-input" :rules="rules" style="width: 100%;"
      label-width="100px" :size="defaultFormItemSize" label-position="right" @submit.native.prevent>
      <el-row :gutter="20">
        <el-col :span="16">
          <el-form-item label="标题" prop="PaNotify.title">
            <el-input class="input-item" v-model="formData.PaNotify.title"
              :clearable="true" placeholder="标题"
            />
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="启用" prop="PaNotify.status">
            <el-radio-group class="input-item" v-model="formData.PaNotify.status"
              @change="onStatusValueChange"
            >
              <el-radio v-for="item in EditPaNotify.status.impl.dropdownList" :key="item.id"
                :label="item.id"
              >
                {{item.name}}
              </el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="类型" prop="PaNotify.type">
            <el-select class="input-item" v-model="formData.PaNotify.type" :clearable="true" filterable
              placeholder="类型" :loading="EditPaNotify.type.impl.loading"
              @visible-change="EditPaNotify.type.impl.onVisibleChange"
              @change="onTypeValueChange">
              <el-option v-for="item in EditPaNotify.type.impl.dropdownList" :key="item.id" :value="item.id" :label="item.name" />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="开始时间" prop="PaNotify.releaseStartTime">
            <el-date-picker class="input-item" v-model="formData.PaNotify.releaseStartTime" :clearable="true"
              format="yyyy-MM-dd"
              value-format="yyyy-MM-dd 00:00:00"
              type="date" align="left"
              placeholder="发布开始时间"
            />
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="结束时间" prop="PaNotify.releaseEndTime">
            <el-date-picker class="input-item" v-model="formData.PaNotify.releaseEndTime" :clearable="true"
              format="yyyy-MM-dd"
              value-format="yyyy-MM-dd 00:00:00"
              type="date" align="left"
              placeholder="发布结束时间"
            />
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="内容" prop="PaNotify.content">
            <el-input class="input-item" v-model="formData.PaNotify.content"
              :clearable="true" placeholder="内容" type="textarea" aria-rowcount="5" :autosize="{minRows: 5}"
            />
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="链接" prop="PaNotify.linkUrl">
            <el-input class="input-item" v-model="formData.PaNotify.linkUrl"
                      :clearable="true" placeholder="链接" type="textarea" autosize
            />
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="附件" prop="PaNotify.attachmentUrl">
            <el-upload name="uploadFile" :headers="getUploadHeaders" multiple
              :action="getUploadActionUrl('/admin/app/paNotify/upload')"
              :data="{fieldName: 'attachmentUrl', asImage: false}"
              :on-success="onAttachmentUrlUploadSuccess"
              :on-remove="onAttachmentUrlRemoveFile"
              :on-error="onUploadError" :on-exceed="onUploadLimit"
              :limit="EditPaNotify.attachmentUrl.impl.maxCount"
              :file-list="EditPaNotify.attachmentUrl.impl.fileList"
              :show-file-list="true">
              <el-button :size="defaultFormItemSize" type="primary">点击上传</el-button>
            </el-upload>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-row class="no-scroll flex-box" type="flex" justify="end">
            <el-button type="primary" :size="defaultFormItemSize" :disabled="!checkPermCodeExist('EditPaNotify:EditPaNotify:update')"
              @click="onUpdateClick()">
              保存
            </el-button>
          </el-row>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>

<script>
/* eslint-disable-next-line */
import { findTreeNode, findTreeNodePath, findItemFromList } from '@/utils';
/* eslint-disable-next-line */
import rules from '@/utils/validate.js';
/* eslint-disable-next-line */
import { DropdownWidget, TableWidget, UploadWidget, ChartWidget } from '@/utils/widget.js';
/* eslint-disable-next-line */
import { uploadMixin, statsDateRangeMixin } from '@/core/mixins';
/* eslint-disable-next-line */
import { PaNotifyController, DictionaryController } from '@/api';

export default {
  name: 'EditPaNotify',
  props: {
    // 是否支持级联操作
    supportCascadeAdd: {
      type: String,
      default: '0'
    },
    // 级联操作数据
    rowData: {
      type: Object
    },
    id: {
      default: undefined
    }
  },
  mixins: [uploadMixin, statsDateRangeMixin],
  data () {
    return {
      formData: {
        PaNotify: {
          id: undefined,
          title: undefined,
          status: undefined,
          type: undefined,
          content: undefined,
          linkUrl: undefined,
          attachmentUrl: undefined,
          releaseStartTime: undefined,
          releaseEndTime: undefined,
          createUserId: undefined,
          createTime: undefined,
          updateUserId: undefined,
          updateTime: undefined,
          paNotifyLine: {
          },
          isDatasourceInit: false
        }
      },
      rules: {
        'PaNotify.title': [
          {required: true, message: '请输入标题', trigger: 'blur'}
        ],
        'PaNotify.type': [
          {required: true, message: '请输入类型', trigger: 'blur'}
        ],
        'PaNotify.content': [
          {required: true, message: '请输入内容', trigger: 'blur'}
        ],
        'PaNotify.releaseStartTime': [
          {required: true, message: '请输入开始时间', trigger: 'blur'}
        ],
        'PaNotify.releaseEndTime': [
          {required: true, message: '请输入结束时间', trigger: 'blur'}
        ]
      },
      EditPaNotify: {
        formFilter: {
        },
        formFilterCopy: {
        },
        status: {
          impl: new DropdownWidget(this.loadStatusDropdownList)
        },
        type: {
          impl: new DropdownWidget(this.loadTypeDropdownList)
        },
        attachmentUrl: {
          impl: new UploadWidget(10)
        },
        btnDiv: {
          isInit: false
        },
        isInit: false
      }
    }
  },
  methods: {
    onCancel (isSuccess, data) {
      if (this.observer != null) {
        this.observer.cancel(isSuccess, data);
      }
    },
    /**
     * 启用下拉数据获取函数
     */
    loadStatusDropdownList () {
      return new Promise((resolve, reject) => {
        let params = {};
        DictionaryController.dictYN(this, params).then(res => {
          resolve(res.getList());
        }).catch(e => {
          reject(e);
        });
      });
    },
    /**
     * 启用选中值改变
     */
    onStatusValueChange (value) {
    },
    /**
     * 类型下拉数据获取函数
     */
    loadTypeDropdownList () {
      return new Promise((resolve, reject) => {
        let params = {groupCode: 'pa_notify_type'};
        DictionaryController.dictSysDictByGroupCode(this, params).then(res => {
          resolve(res.getList());
        }).catch(e => {
          reject(e);
        });
      });
    },
    /**
     * 类型选中值改变
     */
    onTypeValueChange (value) {
    },
    /**
     * 更新编辑公告
     */
    refreshEditPaNotify (reloadData = false) {
      this.loadPaNotifyData().then(res => {
        if (!this.EditPaNotify.isInit) {
          // 初始化下拉数据
          this.EditPaNotify.status.impl.onVisibleChange(true).catch(e => {});
        }
        this.EditPaNotify.isInit = true;
      }).catch(e => {});
    },
    /**
     * 保存
     */
    onUpdateClick () {
      this.$refs.EditPaNotify.validate((valid) => {
        if (!valid) return;
        // 如果是级联表格的添加或者编辑弹窗
        if (this.supportCascadeAdd === '1') {
          let formData = {
            statusDictMap: findItemFromList(this.EditPaNotify.status.impl.dropdownList, this.formData.PaNotify.status, 'id'),
            typeDictMap: findItemFromList(this.EditPaNotify.type.impl.dropdownList, this.formData.PaNotify.type, 'id'),
            ...this.formData.PaNotify
          };
          this.onCancel(true, formData);
          return;
        }

        let params = {
          paNotifyDto: {
            id: this.id,
            title: this.formData.PaNotify.title,
            type: this.formData.PaNotify.type,
            status: this.formData.PaNotify.status,
            content: this.formData.PaNotify.content,
            attachmentUrl: this.formData.PaNotify.attachmentUrl,
            linkUrl: this.formData.PaNotify.linkUrl,
            releaseStartTime: this.formData.PaNotify.releaseStartTime,
            releaseEndTime: this.formData.PaNotify.releaseEndTime
          }
        };

        PaNotifyController.update(this, params).then(res => {
          this.$message.success('保存成功');
          this.onCancel(true);
        }).catch(e => {});
      });
    },
    /**
     * 获取公告通知详细信息
     */
    loadPaNotifyData () {
      return new Promise((resolve, reject) => {
        if (!this.formData.PaNotify.isDatasourceInit) {
          if (
            this.id == null
          ) {
            this.resetFormData();
            reject();
            return;
          }
          let params = {
            id: this.id
          };
          PaNotifyController.view(this, params).then(res => {
            this.formData.PaNotify = {...res.data, isDatasourceInit: true};
            this.EditPaNotify.status.impl.onVisibleChange(true).catch(e => {});
            if (this.formData.PaNotify.typeDictMap && this.EditPaNotify.type.impl.dirty) {
              this.EditPaNotify.type.impl.dropdownList = [this.formData.PaNotify.typeDictMap];
            }
            let attachmentUrlDownloadParams = {
              id: this.formData.PaNotify.id,
              fieldName: 'attachmentUrl',
              asImage: false
            }
            this.EditPaNotify.attachmentUrl.impl.fileList = this.parseUploadData(this.formData.PaNotify.attachmentUrl, attachmentUrlDownloadParams);
            resolve();
          }).catch(e => {
            reject();
          });
        } else {
          this.formData.CourseSection.isDatasourceInit = true;
          resolve();
        }
      });
    },
    initFormData () {
    },
    /**
     * 附件上传成功
     */
    onAttachmentUrlUploadSuccess (response, file, fileList) {
      if (response.success) {
        file.downloadUri = response.data.downloadUri;
        file.filename = response.data.filename;
        file.url = URL.createObjectURL(file.raw);
        this.EditPaNotify.attachmentUrl.impl.onFileChange(file, fileList);
        this.formData.PaNotify.attachmentUrl = this.fileListToJson(this.EditPaNotify.attachmentUrl.impl.fileList);
      } else {
        this.$message.error(response.message);
      }
    },
    /**
     * 移除附件
     */
    onAttachmentUrlRemoveFile (file, fileList) {
      this.EditPaNotify.attachmentUrl.impl.onFileChange(file, fileList);
      this.formData.PaNotify.attachmentUrl = this.fileListToJson(this.EditPaNotify.attachmentUrl.impl.fileList);
    },
    onUploadError (e, file, fileList) {
      this.$message.error('文件上传失败');
    },
    onUploadLimit (files, fileList) {
      this.$message.error('已经超出最大上传个数限制');
    },
    /**
     * 重置表单数据
     */
    resetFormData () {
      this.formData = {
        PaNotify: {
          id: undefined,
          title: undefined,
          status: undefined,
          type: undefined,
          content: undefined,
          attachmentUrl: undefined,
          linkUrl: undefined,
          releaseStartTime: undefined,
          releaseEndTime: undefined,
          createUserId: undefined,
          createTime: undefined,
          updateUserId: undefined,
          updateTime: undefined,
          paNotifyLine: {
          },
          isDatasourceInit: false
        }
      }
    },
    formInit () {
      this.refreshEditPaNotify();
    }
  },
  computed: {
  },
  mounted () {
    // 初始化页面数据
    this.formInit();
    // 初始化级联数据
    if (this.supportCascadeAdd === '1' && this.rowData != null) {
      this.formData.PaNotify = {
        ...this.rowData
      }
    }
  },
  watch: {
  }
}
</script>
